import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import { Typography } from "@material-ui/core";
import { connect } from "react-redux";
import identityService from "../services/identityService";
import { auth } from "../config/firebase";
import { loginWithCustomToken } from "../services/authService";
import Loading from "../components/isLoading";
import FixedAlert from "../components/alert";
import { setCurrentUser } from "../redux/auth/index";
import currentUserClaims from "../utils/currentUserClaims";

export class AuthProvider extends Component {
	state = {
		loading: false,
	};

	handleAuthCheck = async () => {
		const resp = await identityService({
			path: "/auth/status",
			method: "GET",
		});
		if (resp.error && resp.status === 401) {
			window.location.assign(
				`${process.env.IDENTITY_UI}/login?redUrl=${window.location.protocol}//${window.location.host}${window.location.pathname}`
			);
		} else if (resp.error) {
			this.setState({ setupComplete: true, loading: false });
		} else {
			const currentUser = JSON.parse(localStorage.getItem("au"));
			if (
				!currentUser ||
				(resp.results && currentUser.uid !== resp.results.uid)
			) {
				this.setState({ firstTime: true });
				const user = await loginWithCustomToken(
					resp.results && resp.results.customToken
				);
				if (user.error) {
					this.setState({
						error: user.message,
						loading: false,
						setupComplete: true,
					});
				} else this.setState({ setupComplete: true });
			} else {
				this.setState({ setupComplete: true });
			}
		}
	};

	componentDidMount() {
		// // Mocked user
		// const user = {
		// 	displayName: "Francois Mugorozi",
		// 	email: "mfrancois.dev@gmail.com",
		// 	photo:
		// 		"https://lh3.googleusercontent.com/a/ACg8ocJ-uBSGrhCF2UXRTMBByoUTg8E29m6soQ1hNct8mgaOHQ=s96-c",
		// 	uid: "iljkDItaPxVdOjf0lHjtrgSIKFp2",
		// 	phoneNumber: null,
		// 	emailVerified: true,
		// 	claims: {
		// 		userApp: {
		// 			appId: "nonehodemand1622636146746",
		// 			role: "owner",
		// 		},
		// 		userOrg: {
		// 			orgId: "bosconshutiministry1745919868278",
		// 			role: "owner",
		// 			name: "Bosco Nshuti Ministry",
		// 			canViewStats: true,
		// 		},
		// 	},
		// 	atkn: "eyJhbGciOiJSUzI1NiIsImtpZCI6IjY3ZDhjZWU0ZTYwYmYwMzYxNmM1ODg4NTJiMjA5MTZkNjRjMzRmYmEiLCJ0eXAiOiJKV1QifQ.eyJuYW1lIjoiRnJhbmNvaXMgTXVnb3JvemkiLCJwaWN0dXJlIjoiaHR0cHM6Ly9saDMuZ29vZ2xldXNlcmNvbnRlbnQuY29tL2EtL0FDTlBFdTh1TVVNMVlnX3ZDRnZwSkd6dG1hNklpSmhobEN0RjBnc0dSRlZrPXM5Ni1jIiwiYXBwcyI6W3siYXBwSWQiOiJub25laG9pZGVudGl0eTE2MTc4NzkzMzI3NjAiLCJyb2xlIjoib3duZXIifSx7ImFwcElkIjoibm9uZWhvZGVtYW5kMTYyMjYzNjE0Njc0NiIsInJvbGUiOiJvd25lciJ9LHsiYXBwSWQiOiJpbnlhcndhbmRhbmV3czE3MDE3NzIwODEyOTIiLCJyb2xlIjoib3duZXIifV0sIm9yZ2FuaXphdGlvbnMiOlt7ImFwcHMiOlt7ImFwcElkIjoibm9uZWhvZGVtYW5kMTYyMjYzNjE0Njc0NiIsInJvbGUiOiJvd25lciJ9XSwib3JnSWQiOiJmcmVtb2lyZTE2NjQ3MDg2ODk4NDYifV0sImlzcyI6Imh0dHBzOi8vc2VjdXJldG9rZW4uZ29vZ2xlLmNvbS9ub25laG9pZGVudGl0eSIsImF1ZCI6Im5vbmVob2lkZW50aXR5IiwiYXV0aF90aW1lIjoxNzQ2MjY5NTEzLCJ1c2VyX2lkIjoia0YwSlNCT0NRaFJxazByM0NFZWpZU25VbjJzMSIsInN1YiI6ImtGMEpTQk9DUWhScWswcjNDRWVqWVNuVW4yczEiLCJpYXQiOjE3NDcyOTcyMjYsImV4cCI6MTc0NzMwMDgyNiwiZW1haWwiOiJmcmFuY29pc0BpbnlhcndhbmRhLmNvbSIsImVtYWlsX3ZlcmlmaWVkIjp0cnVlLCJmaXJlYmFzZSI6eyJpZGVudGl0aWVzIjp7Imdvb2dsZS5jb20iOlsiMTE1OTI1MDQ2MjQyMjA0MzQ1MzMxIl0sImVtYWlsIjpbImZyYW5jb2lzQGlueWFyd2FuZGEuY29tIl19LCJzaWduX2luX3Byb3ZpZGVyIjoiZ29vZ2xlLmNvbSJ9fQ.KVXi3TV-r3J_C3pjEkfmyLQ7Hw_TYNVSa7nQCo6rLQqDoRwV8LD-SOxvnjrB2FUmcPuKmRc44_ob1IJLzBJtv5tpTZBh_NYZHHMTQpRwY3h20KpfAnFj9i2uvbULtlN08725n86KGjwiFHtwsai7Q2jo0jRQC6zllmICCJjkWhdOw7LLmxn1dwYLWmzSL2L2rTpimMC66mobswfYHz09Rgvx70n0s1x4g4MAw9XOYC_wHTetVVxSlZZHCMgNlji7YtJP9w5jgmldeLQbSvzeMBHtrRlQsd9JADH3UWlF3CeUOxUbbt3WKCIpK-iIauK-BTJGuj6aWxJ6xGJk62kIAQ",
		// };
		// localStorage.setItem("au", JSON.stringify(user));

		// // end of mocked user

		if (!localStorage.getItem("autoReload")) {
			this.handleAuthCheck();
		} else {
			localStorage.removeItem("autoReload");
		}
		this.onAuthChange = auth.onAuthStateChanged(async (currentUser) => {
			if (currentUser) {
				try {
					const userData = await currentUser.getIdTokenResult(true);

					const user = {
						displayName: currentUser.displayName,
						email: currentUser.email,
						photo: currentUser.photoURL,
						uid: currentUser.uid,
						phoneNumber: currentUser.phoneNumber,
						emailVerified: currentUser.emailVerified,
						claims: await currentUserClaims(userData.claims),
					};
					localStorage.setItem(
						"au",
						JSON.stringify({
							...user,
							atkn: userData.token,
						})
					);
					this.props.setCurrentUser(user);
					if (this.state.firstTime) {
						localStorage.setItem("autoReload", "on first time");
						window.location.reload();
					} else this.setState({ loading: false });
				} catch (error) {
					console.log(error);
					this.setState({ loading: false });
				}
			} else {
				if (this.state.setupComplete) {
					window.location.assign(
						`${process.env.IDENTITY_UI}/login?redUrl=${window.location.protocol}//${window.location.host}${window.location.pathname}`
					);
				} else {
					this.setState({
						loading: !this.state.setupComplete,
						error:
							currentUser && !currentUser.emailVerified
								? "Your account is not verified"
								: this.state.setupComplete &&
								  "Authentication failed, retry or contact administrator",
					});
				}
			}
		});

		setInterval(async () => {
			const token = await auth.currentUser.getIdToken(true);
			const currentUser = JSON.parse(localStorage.getItem("au"));
			currentUser.atkn = token;
			localStorage.setItem("au", JSON.stringify(currentUser));
		}, 56 * 60 * 1000);
	}

	componentWillUnmount() {
		this.onAuthChange();
	}
	render() {
		return (
			<div>
				{this.state.loading ? (
					<Box padding={2}>
						<Grid
							container
							justifyContent="center"
							alignItems="center"
							direction="column"
						>
							<Loading />
							<Typography align="center">Please wait a moment...</Typography>
						</Grid>
					</Box>
				) : this.state.error && this.state.setupComplete ? (
					<Box padding={2}>
						<Grid
							container
							justifyContent="center"
							alignItems="center"
							direction="column"
						>
							<FixedAlert title={this.state.error} type="warning" />
						</Grid>
					</Box>
				) : (
					this.props.children
				)}
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	currentUser: state.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
	setCurrentUser: (user) => dispatch(setCurrentUser(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AuthProvider);
